<template>
  <div class="qr-wrap">
    <canvas ref="canvas" :style="{ width: size + 'px', height: size + 'px' }"></canvas>
  </div>
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'QrCode',
  props: {
    value:  { type: String, required: true },
    size:   { type: Number, default: 180 },
    level:  { type: String, default: 'M' } // L, M, Q, H
  },
  watch: {
    value: 'render',
    size: 'render',
    level: 'render'
  },
  mounted () {
    this.render()
  },
  methods: {
    async render () {
      const opts = {
        errorCorrectionLevel: this.level,
        width: this.size,
        margin: 1,
        color: { dark: '#000000', light: '#FFFFFF' }
      }
      await QRCode.toCanvas(this.$refs.canvas, this.value || '', opts)
    },
    toDataUrl () {
      return this.$refs.canvas.toDataURL('image/png')
    }
  }
}
</script>

<style scoped>
.qr-wrap { display: inline-block; }
</style>
